<template>
    <div class="message">
        <div class="retreat" @click="retreat">
            <van-icon name="arrow-left" color="#fff" />
        </div>
        <div class="title">{{ $t('message.user.my_award') }}</div>
        <div class="context" v-show="certslist.length >= 1">

            <div class="infrom" v-for="(item, index) in certslist " :key="index">
                <div class="finalist_inform_box">
                    <p style="margin:10px 0px; font-size:14px;">{{ arr[index] }}</p>

                    <div class="finalist_inform_text" @click="detailsClick(item.workId, item.award)">
                        <p class="awardstext">{{ item.activeName }}</p>
                        <p class="awards_priez">{{ item.award }}</p>
                    </div>
                </div>
            </div>


        </div>
        <div class="context" v-show="certslist.length == 0">
            <div class="show_img">
                <img src="../../../../static/image/no_infrom.png" alt="" />
                <p class="no_crea">{{ $t('message.user.no_award') }}</p>
            </div>
        </div>

    </div>
</template>
<script>
import { awlist } from '@/api/user.js'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            certslist: [],
            pageSize: 1,
            pageNum: 10,
            pages: 1,
            arr:[]
        }
    },
    //监听属性 类似于data概念
    computed: {


    },
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        retreat() {
            // 返回上一级
            this.$router.go(-1)
        },
        async awlist() {
            const { data: res } = await awlist({ pageSize: 10, pageNum: this.pages })
            if (res.resultCode == 200) {
                this.certslist = res.data.list
           
                for (let i = 0; i < res.data.list.length; i++) {
                    if (!this.arr.includes(res.data.list[i].updateTime)) {
                        this.arr[i] = res.data.list[i].updateTime;
                    } else {
                        this.arr[i] = "";
                    }
                }
                
            }
            
            // for (var i = 0; i <= res.data.list.length; i++) {
            //     for (var j = 1; j <= res.data.list.length; j++) {
            //         console.log(res.data.list[j].updateTime);
            //         if (res.data.list[i].updateTime === res.data.list[j].updateTime) {
            //             console.log(res.data.list[j].updateTime);
            //         }
            //     }

            // }

        },
        detailsClick(workId, award) {
            this.$router.push({
                name: 'worksDetails',
                query: { id: workId, award: award ,conditionsOfVoting:'2'}
            })
        }


    },
    //生命周期 - 创建完成(可以访问当前this实例)
    created() {
        this.awlist()

    },
    //生命周期 - 挂载完成(可以访问DOM元素)
    mounted() {

    }
}
</script>
<style scoped lang="less">
* {
    margin: 0px;
    padding: 0px;
}

.message {
    width: 100%;
    //height: 100vh;
    overflow: auto;
    box-sizing: border-box;
    background-size: 100% 172px;
    background-image: url('../../../../static/image/user_bjt.png');
    background-repeat: no-repeat;
    position: relative;

    .retreat {
        position: absolute;
        top: 44px;
        left: 26px;
    }

    .title {
        text-align: center;
        font-size: 16px;
        color: #fff;
        margin-top: 43px;
    }

    .context {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        background-color: #fff;
        margin-top: 15px;
        border-radius: 30px 30px 0 0;
        padding: 27px 15px 0 25px;

        .img_box {
            margin: 0px 30px;

            p {
                padding: 20px 0px;
            }
        }

        .finalist_inform_text {
            width: 325px;
            height: 48px;
            border: 0.5px solid #F6F6F6;
            background: #f3efef;
            border-radius: 14px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .awardstext {
                width: 167px;
                margin-left: 16px;
                font-size: 14px;
                /*要显示文字的宽度*/
                text-overflow: ellipsis;
                /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
                white-space: nowrap;
                /*让文字不换行*/
                overflow: hidden;
                overflow: hidden;
            }

            .awards_priez {
                //width: 55px;
                padding: 0px 4px;
                height: 24px;
                border: 1px solid #DE8552;
                border-radius: 4px;
                font-size: 12px;
                line-height: 24px;
                /* identical to box height */
                margin-right: 27px;
                text-align: center;
                letter-spacing: -0.3px;
                background-color: #fff;
                color: #DE8552;
            }
        }




    }

    .show_img {
        position: relative;
        bottom: 0px;
        display: flex;
        justify-content: center;
        height: 250px;

        img {
            width: 200px;
            height: 150px;
        }

        .no_crea {
            position: absolute;
            bottom: 43px;
            color: darkgray;
        }
    }
}
</style>